import { useQuery } from "@tanstack/react-query";
import { boronClient } from "../../api";
import { createError } from "../../errors";

export const useFetchAllStudentLearningMaterials = ({
  studentId,
}: {
  studentId: string;
}) =>
  useQuery({
    queryKey: ["/api/v1/students/{student_id}/learning_materials", studentId],
    queryFn: async () => {
      const { response, data } = await boronClient.GET(
        "/api/v1/students/{student_id}/learning_materials",
        {
          params: {
            path: {
              student_id: studentId,
            },
            query: {
              type: "all",
            },
          },
        },
      );
      if (response.ok && data) {
        return data.learningMaterials;
      }
      throw await createError(response);
    },
  });
